import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { IonItem, IonLabel, IonInput, IonCol, InputCustomEvent } from '@ionic/vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'PgsInputFill',
  props: {
	color: {
		type: String,
		default: '',
	},
	label: {
		type: String,
		default: 'Label',
	},

	modelValue: {
		type: [String, Number],
		default: '',
	},
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {



const handleFocusIn = ($event: InputCustomEvent) => {
	// For some reason when set '' this does nothing. But this does the trick.
	emit('update:modelValue', Number($event.target.value) === 0 ? ' ' : $event.target.value );
}
	
const handleFocusOut = ($event: InputCustomEvent) => {
	emit('update:modelValue', !$event.target.value ? 0 : $event.target.value );
}

const handleInput = ($event: InputCustomEvent) => {
	emit('update:modelValue', $event.target.value);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCol), { class: "pgs-fill-input" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonItem), {
        lines: "none",
        mode: "md"
      }, {
        default: _withCtx(() => [
          (__props.label)
            ? (_openBlock(), _createBlock(_unref(IonLabel), {
                key: 0,
                color: __props.color,
                position: "stacked"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.label), 1)
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonInput), {
            color: __props.color,
            type: "number",
            inputmode: "tel",
            autocomplete: "off",
            placeholder: __props.label,
            autocorrect: "off",
            value: __props.modelValue,
            onInput: handleInput,
            onFocusin: handleFocusIn,
            onFocusout: handleFocusOut
          }, null, 8, ["color", "placeholder", "value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})